













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramMeta extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: string[];
  @Prop({ type: Boolean, default: false }) left!: boolean;
  @Prop({ type: Boolean, default: false }) strongFirst!: boolean;

  get shown() {
    return this.items.filter((item) => item);
  }
}
